import {ROWS_PER_PAGE} from '../constants/rowsPerPage';

type ListEndReachedCache = {
  isEndReached?: boolean;
};

export function updateListEndReached(cache: ListEndReachedCache, fetchedRowCount: number): void {
  cache.isEndReached = fetchedRowCount < ROWS_PER_PAGE;
}
